import React, { useState, useRef, useEffect } from 'react';
import 'flag-icons/css/flag-icons.min.css';
import './LanguagePicker.css';
import { useTranslation } from '../../store/context/TranslationContext';
import { LuLanguages } from 'react-icons/lu'; // Import the icon
import { buildAutomationChildTestId, resolveAutomationTestId } from '../InputField/testId';

const options = [
    { value: 'en', label: 'English', icon: 'gb' },
    // { value: 'hi', label: 'हिन्दी', icon: 'in' }, 
    { value: 'es', label: 'Español', icon: 'es' },  
    { value: 'ja', label: '日本語', icon: 'jp' },
];


const LanguagePicker = ({ testId }) => {
    const { changeLanguage, language } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const selectedOption = options.find((o) => o.value === language) || options[0];
    const dropdownRef = useRef(null);
    const resolvedTestId = resolveAutomationTestId(testId);

    const toggleDropdown = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    const handleOptionClick = (option) => {
        changeLanguage(option.value);
        setIsOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="fv_language-selector" ref={dropdownRef} data-testid={resolvedTestId}>
            <div className="fv_language-dropdown" data-testid={buildAutomationChildTestId(resolvedTestId, "dropdown")}>
                <button
                    className="fv_language-toggle"
                    onClick={toggleDropdown}
                    type="button"
                    data-testid={buildAutomationChildTestId(resolvedTestId, "toggle")}
                >
                    <div className='fv_language-icon-body'> <LuLanguages className="fv_language-icon" /> </div>{/* LuLanguages icon */}
                    <span className={`fi fi-${selectedOption.icon}`}></span>
                    <span className="fv_language-selected">
                        {selectedOption.label} {/* Show selected label */}
                    </span>
                </button>
                {isOpen && (
                    <ul className="fv_language-menu" data-testid={buildAutomationChildTestId(resolvedTestId, "menu")}>
                        {options.map((option) => (
                            <li
                                key={option.value}
                                className="fv_language-item"
                                onClick={() => handleOptionClick(option)}
                                data-testid={buildAutomationChildTestId(resolvedTestId, `option-${option.value}`)}
                            >
                                <span className={`fi fi-${option.icon}`}></span>
                                <span className="fv_language-option-label">
                                    {option.label}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default LanguagePicker;
